<template>
    <div ref="slide"
        @click="clicked" 
        @mouseover="over"
        @mouseout="out" 
        class="slide" 
        :class="pos"
        :style="{backgroundImage: 'url(' + source + ')'}">
        <p ref="title" class="title">{{ title }}</p>
    </div>
</template>

<script>
import store from '../store/Store';

export default {
    props: {
        title: String,
        source: String,
        pos: String 
    },
    data() {
        return {
            state: store.state
        }
    },
    methods: {
        clicked() {
            this.$emit('clicked');
        },
        over() {
            if (!this.state.freeze) {
                const {slide, title} = this.$refs;

                let tl = new TimelineMax();
                tl
                .to(title, 1, {letterSpacing: '1.3rem', ease: Expo.easeOut})
                .to(slide, 1, {scale: 1.1, ease: Expo.easeOut}, '-=1');
            }
        },
        out() {
            if (!this.state.freeze) {
                const {slide, title} = this.$refs;

                let tl = new TimelineMax();
                tl
                .to(title, 1, {letterSpacing: '1rem', ease: Expo.easeOut})
                .to(slide, 1, {scale: 1, ease: Expo.easeOut}, '-=1');
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Slide.vue